import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { PageWrapper } from "../../../components/PageWrapper";
import { VideoScriptsTable } from "./components/VideoScriptsTable";

type Props = RouteComponentProps;

const VideoScriptsFC: React.FC<Props> = ({ history }) => {
  React.useEffect(() => {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }, []);

  return (
    <PageWrapper title={"Video Scripts"} hideSeparator={true}>
      <VideoScriptsTable />
    </PageWrapper>
  );
};

export const VideoScriptsPage = VideoScriptsFC;
